export function setAuthCookie(token: string, expireTime?: string | number | Date) {
    const expires = expireTime ? new Date(expireTime) : new Date();
    if (!expireTime) {
        expires.setDate(expires.getDate() + 1); // 默认1天过期
    }
    document.cookie = `token=${token}; expires=${expires.toUTCString()}; path=/`;
}

export function clearAuthCookie() {
    document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}